import { useEffect } from "react";
import volumeUpIcon from "../../assets/volume_up.svg";
import { Button, Box } from "@mui/material";
import "./CohortAudioPlayer.css";

const CohortAudioPlayer = ({
  isPlaying,
  playAudio,
  stopAudio,
  buttonStyle,
  iconStyle,
}) => {
  useEffect(() => {
    return () => stopAudio();
  }, []);

  return (
    <Box>
      <Button
        variant="contained"
        disableElevation
        disabled={!!isPlaying}
        onClick={playAudio}
        className="cohort-audio-button"
        sx={buttonStyle}
      >
        <Box
          component="img"
          src={volumeUpIcon}
          alt="Play Audio"
          className="cohort-volume-icon"
          sx={iconStyle}
        />
      </Button>
    </Box>
  );
};

export default CohortAudioPlayer;
